import {createSelector} from '@reduxjs/toolkit';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {Playlist, Song} from '../../api/types';

export const LIKED_SONGS_ID = 'user-liked-songs';
export const LIKED_SONGS_NAME = 'Liked Songs';

const selectLikedSongsState = (state: RootState) => state.likedSongs;

export const selectLikedSongsList = createSelector(
    [selectLikedSongsState],
    (s): Song[] => s.order.map(id => s.songs[id]).filter(Boolean),
);

export const selectIsLiked = createSelector(
    [selectLikedSongsState, (_s: RootState, id: string) => id],
    (s, id): boolean => !!s.songs[id],
);

export const selectLikedSongsPlaylist = createSelector(
    [selectLikedSongsList],
    (tracks): Playlist => ({
        id: LIKED_SONGS_ID,
        name: LIKED_SONGS_NAME,
        artist: `${tracks.length} ${tracks.length === 1 ? 'song' : 'songs'}`,
        img: tracks[0]?.img ?? '',
        tracks,
    }),
);

export const useIsLiked = (id: string) =>
    useSelector((state: RootState) => selectIsLiked(state, id));

export const useLikedSongs = () => useSelector(selectLikedSongsList);

export const useLikedSongsPlaylist = () => useSelector(selectLikedSongsPlaylist);
